import * as React from 'react';

export const usePreviewWindow = () => {
    const [externalWindow, setExternalWindow] = React.useState<Window | undefined>(undefined);

    React.useEffect(() => {
        return () => {
            if (externalWindow) {
                externalWindow.close();
            }
        };
    }, [externalWindow]);

    return { externalWindow, setExternalWindow };
};
